// extracted by mini-css-extract-plugin
export default {"block_parent":"block-module__block_parent___rU5f2"};